import AOS from "aos";
import App from "./App.svelte";

AOS.init({
  duration: 2000,
  delay: 300,
  once: true
});

const app = new App({
	target: document.body,
});

export default app;